import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";

const accentClass: Record<string, string> = {
  accent: "bg-accent-500/15 text-accent-400",
  secondary: "bg-secondary-500/15 text-secondary-400",
  primary: "bg-primary-400/20 text-primary-200"
};

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
      {categories.map((category, index) => (
        <Link
          key={category.key}
          to={`/category/${category.key}`}
          className="group flex cursor-pointer flex-col rounded-lg border border-background-800 bg-background-900 p-4 transition-colors duration-300 hover:border-accent-500/70 hover:bg-background-800 animate-fade-up"
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <span
            className={`flex h-11 w-11 items-center justify-center rounded-md ${
              accentClass[category.accent] || accentClass.accent
            }`}
          >
            <i className={`${category.icon} text-xl`} aria-hidden="true" />
          </span>
          <h3 className="mt-3 font-heading text-base font-600 text-foreground-50">
            {category.label}
          </h3>
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {category.description}
          </p>
        </Link>
      ))}
    </div>
  );
}